import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { IconButton, Tooltip, alpha, useTheme } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import useUser from "../../Core/hook/useUser";
import { Privileges } from "../../Core/Enum/enum";
import HelpDrawer from "./HelpDrawer";

/**
 * Topbar Help icon. Opens a right-side drawer with the article that
 * matches the user's current route (falls back to a "no article yet"
 * state with links into /help-center).
 *
 * Renders nothing for users without HelpArticle_View so unauthenticated
 * or unlicensed contexts stay clean.
 */
const HelpButton: React.FC = () => {
  const theme = useTheme();
  const { userHasRight } = useUser();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  if (!userHasRight(Privileges.HelpArticleView)) return null;

  return (
    <>
      <Tooltip title="Help & Documentation">
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 38, height: 38, borderRadius: "10px",
            color: theme.palette.text.secondary,
            "&:hover": {
              bgcolor: alpha(theme.palette.primary.main, 0.06),
              color: theme.palette.primary.main,
            },
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
      <HelpDrawer open={open} onClose={() => setOpen(false)} route={location.pathname} />
    </>
  );
};

export default HelpButton;
